import { makeStyles } from '@material-ui/core/styles'
import { IProps } from './Interface'
import { theme } from 'config/constants/theme/theme'

export default makeStyles<{}, IProps>({
  root: ({ size, background, borderRadius, padding }) => ({
    height: size?.height,
    width: size?.width,
    background: background,
    borderRadius: `${borderRadius?.topLeft?.toString() || 12}px ${borderRadius?.topRight?.toString() ||
      12}px ${borderRadius?.bottomRight?.toString() || 12}px ${borderRadius?.bottomLeft?.toString() || 12}px`,
    padding: padding,
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      padding: '15px 20px'
    }
  }),
  animated: {}
})
